import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { switchMap } from 'rxjs/operators';
/*App imports*/
import { HelpersService, TiposCalculos, OpcionesPago } from '../../../../../services/tools/helpers.service';
import { PagosService } from '../../../../../services/pagos.service';
import { ArchivosPagosService } from "../../../../../services/archivos-pagos.service";
import { CarburacionesService } from "../../../../../services/creditos/carburaciones.service";
import { EstacionariosService } from "../../../../../services/creditos/estacionarios.service";
import { BigNumber } from "bignumber.js";

@Component({
  selector: 'agregar-pago-dist',
  templateUrl: './agregar-pago-dist.component.html',
  styleUrls: ['./agregar-pago-dist.component.scss']
})
export class AgregarPagoDistComponent implements OnInit {
  @Input() public idCreditos : number = null;
  @Input() public tipoCalculo : number = null;
  @Input() public isValidToAddPago : number = null;
  @ViewChild('closeBtn') closeBtn: ElementRef;
  @ViewChild('editarPagoBtn') editarPagoBtn: ElementRef;
  @Output() public onPagoCreated : EventEmitter<string> = new EventEmitter;

  public errors: any = {};
  public pago: any = { forma: '', tipo_abono: '', tipo: 1, porcentaje_descuento: null }; //El tipo de pago default es 1=Pago del periodo
  public archivo: any = null;
  public tiposAbonos: any[] = [];
  private carburacion: any = null;
  private estacionario: any = null;

  public opcionesPagos: any []  = [];

  constructor(
    private helperService: HelpersService,
    private pagosService: PagosService,
    private archivosService: ArchivosPagosService,
    private carburacionesService: CarburacionesService,
    private estacionariosService: EstacionariosService
  ){
  }

  public ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.idCreditos && this.tipoCalculo) {
      this.setupComponent(this.tipoCalculo, this.idCreditos);
    }
  }

  private setupComponent(tipoCalculo: number, idCreditos: number){
    switch(tipoCalculo){
      case TiposCalculos.DistribucionCarburacion:
        this.getCreditoCarburacion(idCreditos);    
        break;
      case TiposCalculos.DistribucionEstacionario:
          this.getCreditoEstacionario(idCreditos);    
          break;
    }
  }

  private getCreditoCarburacion(idCreditos : number){
    this.carburacionesService.get(idCreditos).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.carburacion = result.carburacion;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status === 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }

  private getCreditoEstacionario(idCreditos : number){
    this.estacionariosService.get(idCreditos).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.estacionario = result.estacionario;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status === 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }

  public save(){
    this.errors = {};
    let pago = this.pago;    

    //Asignarel tipo de pago con base en el item que este seleccionado
    if(this.pago.abono && this.pago.abono.toString().length > 0){
        this.pago.tipo_abono = 1; //Default abono reducir plazos
    }else{
      //Si no se ingreso un valor en el campo de abono, seteamos estos campos como null
      this.pago.tipo_abono = null;
      this.pago.abono = null;
    }

    //Si no fue definido el descuento asignamos null. Si ominitmos esta asignación se generá un error en el backend
    this.pago.porcentaje_descuento = pago.porcentaje_descuento ? pago.porcentaje_descuento : null;

    this.errors = this.pagosService.validateDistribucion(pago);

    if (Object.entries(this.errors).length > 0) {
      return;
    }

    if(pago.id){
      //Update pago
      this.update(pago);
    }else{
      //Set idCreditos
      pago.idCreditos = this.idCreditos;
      //New pago
      this.create(pago);
    }
  }

  private create(pago : any){
    this.pagosService.save(pago).subscribe(
      (response)=>
      {
        const result = response.json().content;
        this.helperService.notification('Pago creado', 'Se ha registrado exitosamente el pago', 'success');
        this.setupAfterSave();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        if(error.status == 400) {
          this.showBackendError(error.json().content);
        }
      }
    );
  }

  private update(pago: any){
    this.pagosService.update(pago).subscribe(
      (response)=>
      {
        const result = response.json().content;
        this.helperService.notification('Pago actualizado', 'Se ha actualizado exitosamente el pago', 'success');
        this.setupAfterSave();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.showBackendError(error.json().content);
        }
      }
    );
  }

  public calcularTotalRecaudo(){
    //Ya que los litros puede tener un valor de hasta 8 decimales, se utiliza la librería bignumber.js para que las operaciones entre decimales
    //se realice de forma esperada, ya que las operaciones con decimales en JS nativo tiene errores/variaciones
    let bigFactorRecaudo = null;
    
    switch(this.tipoCalculo){
      case TiposCalculos.DistribucionCarburacion:
        bigFactorRecaudo = new BigNumber(this.carburacion.factor_recaudo);
        break;
      case TiposCalculos.DistribucionEstacionario:
        bigFactorRecaudo = new BigNumber(this.estacionario.factor_recaudo);
        break;
    }
        
    let bigLitrosConsumidos = new BigNumber(this.pago.litros_consumidos);
    let bigMontoPago = bigLitrosConsumidos.multipliedBy(bigFactorRecaudo);
    this.pago.monto_pago = bigMontoPago.toFixed(2);
  }

  public setupForNewPago(){
    this.resetPagoModel();
    //Obtener las opciones de pago, ya que despúes de un pago estas pueden haber cambiado
    this.getOpcionesPago(this.idCreditos);
  }
  private resetPagoModel(){
    //se restablecen los valores del pago para que la siguiente ves que se abra el modal, tenga los valores default
    //Reiniciamos el valor de las propiedades de un pago
    this.pago = { forma: '', tipo_abono: '', tipo: 1 };
    //Limpiar la relación con el archivo
    this.archivo = null;
    //Clear errors
    this.errors = [];
  }

  public print(){
    //Imprimir pantalla
    window.print();
  }

  private setupAfterSave(){
    this.onPagoCreated.emit();
    //Cerrar el modal
    this.closeBtn.nativeElement.click();
    this.resetPagoModel();  
  }

  private showBackendError(jsonErrors: any){
    let component = this;
    Object.keys(jsonErrors).forEach(function(key){
      //TODO: Agregar el mapeo de todos los posibles errores en el backend
      switch(key){
      case 'abono':
          component.errors["abono"] = jsonErrors[key];
          component.errors["litros_consumidos"] = jsonErrors[key];
        break;
      case 'fecha':
          component.errors["fecha"] = jsonErrors[key];
          break;
        
      }
    });
  }

  /**
   * Upload files
   */
  public uploadFile(event : any) {

    let fileInfo = 
    {
        idPagos : (this.pago.id) ? this.pago.id : null
    };
    
    let observableResponse = this.archivosService.save(event, fileInfo);
    if(!observableResponse){
      return;
    }

    observableResponse.subscribe(
        (response)=>
        {
          let archivo = response.json().content;
          //Se agrega la info del nuevo archivo a la lista para que se muestre en el formulario
          this.pago.idArchivo = archivo.id;
          this.archivo = archivo;

          //Notify result
          this.helperService.notification('Archivo agregado', 'Se ha agregado exitosamente el archivo', 'success');
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {            
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );   
  }

  public downloadFile() {
    this.archivosService.getFile(this.archivo.id).subscribe(
      (response)=>
      {
        const fileUrl = window.URL.createObjectURL(response.blob());
        //Muestra el archivo en una nueva ventana
        window.open(fileUrl);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  
  public deleteFile(){

    this.archivosService.delete(this.archivo.id).subscribe(
      (response)=>
      {
        //Si el archivo fue eliminado, desasignamos el valor del atributo contratoFile
        this.archivo = null;
        this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  /**
   * Edit mode functions
   */
   public showModalPago(idPago: number){
    this.resetPagoModel();
    //Abrir el modal para editar un pago
    this.editarPagoBtn.nativeElement.click();
    //Cargar los datos del pego a editar
    if(idPago){
      this.getOpcionesPagoAndPagoDetails(idPago);
      this.getArchivoPago(idPago);
    }
  }

  private getOpcionesPagoAndPagoDetails(idPago){
    let opcionesResult = null;
    const ctrl = this;
    this.pagosService.getOpcionesPago(this.idCreditos, idPago).pipe(
      switchMap(opciones => {
        opcionesResult = opciones;  
        return this.pagosService.getPago(idPago)}
        )
    ).subscribe(
      pagoResponse => {
        //Fill dd con opciones de pago
        const opcionesPago = opcionesResult.json().content;
        this.opcionesPagos = opcionesPago;

        const pago = pagoResponse.json().content;
        this.pago = pago;

        //Selecciona el tipo de pago, para mostrar la opción correcta en el combo
        this.opcionesPagos.forEach(function(tipoPago) {
      
          if(tipoPago.opcion === pago.tipo){
            //ctrl.tipoPagoSelected = tipoPago;
          }
        });
      
    }, error =>
    {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);
      
      if(error.status == 400) {
        this.helperService.setBackendErrors(error.json().content, this.errors);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    });
  }

  private getArchivoPago(idPago: number){
    const ctrl = this;
    this.archivosService.get(idPago).subscribe(
      (response)=>
      {
        const archivos = response.json().content;
        if(archivos.length){
          this.archivo = archivos[0];
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getOpcionesPago(idCredito: number, idPago: number = null){
    this.pagosService.getOpcionesPago(idCredito, idPago).subscribe(
      (response)=>
      {
        const opcionesPago = response.json().content;
        this.opcionesPagos = opcionesPago;
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public onChangeTipoPago(){
    //Pago para liquidar el capital pendiente
    if(this.pago.tipo === OpcionesPago.CapitalPendiente){
      this.pago.litros_consumidos = '';
      this.pago.monto_pago = 0;
      let pagoActual = this.pago;

      //Asignar el monto del pago utilizando el valor que se obtuvo del servicio
      this.opcionesPagos.forEach(function(tipoPago) {
        if(tipoPago.opcion === pagoActual.tipo){
          pagoActual.monto_pago = tipoPago.monto;
        }
      });

    }else{
      this.pago.monto_pago = '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/pagos-distribucion/components/agregar-pago/agregar-pago-dist.component.ts